import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import EmptyHeader from "./EmptyHeader";
import { isDevelopmentMode } from "../services/base";

export default function Login({ destination, activeMethod }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, seterror] = useState({ mobile: "", email: "" });
  const [phone, setPhone] = useState(location.state.phone);
  const [email, setEmail] = useState(location.state.email);
  const [password, setPassword] = useState("");
  const [choose] = useState(activeMethod);
  const [flag, setflag] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  function handelCheck(event) {
    event.preventDefault();
    var tagName = event.target.name;
    let p = event.target.value;

    if (tagName == "mobile") {
      var pattern = new RegExp(/^09[0-9]{9}/);

      if (!pattern.test(p)) {
        seterror({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
        setflag(true);
      } else if (p.length == 11) {
        seterror({ ...error, mobile: "" });
        setPhone(p);
        setflag(false);
      } else {
        seterror({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
        setflag(true);
      }
    } else {
      var pattern = /\S+@\S+\.\S+/;
      if (pattern.test(p)) {
        // console.log("hiii");
        seterror({ ...error, email: "" });
        setEmail(p);
        setflag(false);
      } else {
        setflag(true);
        seterror({ ...error, email: "لطفا ایمیل خود را درست وارد نمایید" });
      }
    }
  }
  function handelSubmit(event) {
    let formData = new FormData();
    formData.append(
      isDevelopmentMode() ? "identifier" : "destination_address",
      destination
    );
    formData.append("password", password);
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: "https://api.talaeshow.com/api/users/token/",
      method: "POST",
      headers: {
        // Add any auth token here
      },
      data: formData,
    })
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.message === "OK") {
            navigate("/otp_verify", {
              state: {
                destination: destination,
                isLogin: true,
                activeMethod: activeMethod,
              },
            });
          } else if (res.data.message === "OTP_BYPASS") {
            localStorage.setItem("token", res.data.tokens.access);
            navigate("/");
          }
        }
      })
      .catch((error) => {
        // console.log("error");
        toast.error("رمزعبور یا کد تایید صحیح نیست");
        setIsLoading(false);
        if (error.response) {
          // console.log(error.response);
        } else if (error.request) {
          // console.log(error.request);
        } else if (error.message) {
          // console.log(error.message);
        }
      });
  }

  return (
    <div>
      <EmptyHeader />
      <form className="text-center">
        <h3 className="title-for-login title-for-login-desktop">
          ورود به حساب کاربری
        </h3>
        <div className="container">
          <div className="row justify-content-center h-100 section-padding align-items-center">
            <div className="col-xl-6 col-md-8">
              <div className="row">
                <div className="col-6 text-end">
                  <button
                    type="button"
                    id={"mobile"}
                    name="mobile"
                    className={
                      "btn-choose btn-330" +
                      (choose === "mobile" ? "" : " not-active-login")
                    }
                  >
                    از طریق موبایل
                  </button>
                </div>

                <div className="col-6 text-end">
                  <button
                    type="button"
                    id={"email"}
                    name="email"
                    className={
                      "btn-choose btn-331" +
                      (choose === "email" ? "" : " not-active-login")
                    }
                  >
                    از طریق ایمیل
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="authincation section-padding">
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-xl-6 col-md-8">
                <div className="mini-logo text-center my-2"></div>
                <div className="auth-form custom-shadow">
                  <form>
                    <div className="form-group text-end">
                      <div className="pt-1">
                        {choose === "mobile" ? (
                          <>
                            <span className="pe-2 mynormal">شماره موبایل</span>
                            <div className="input-group mb-3 pt-1">
                              <input
                                type="tel"
                                className="form-control mt-2 myinput ltr"
                                placeholder="مثال 09120195321"
                                id={"mobilein"}
                                name={"mobile"}
                                value={phone}
                                disabled={true}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <span className="pe-2 mynormal">ایمیل</span>
                            <div className="input-group mb-3 pt-1">
                              <input
                                type="email"
                                className="form-control mt-2 myinput ltr"
                                placeholder=" talaeishow@gmail.com مثال "
                                id={"emailin"}
                                name={"email"}
                                value={email}
                                onChange={handelCheck}
                                required
                                disabled={true}
                              />
                            </div>
                          </>
                        )}
                        <span className="pe-2 mynormal">رمزعبور</span>
                        <div className="password-wrapper">
                          <div className="input-group mb-3 pt-1">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control mt-2 myinput ltr"
                              id={"pass"}
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                          </div>
                          <div className="show-pass">
                            {showPassword ? (
                              <div onClick={(e) => setShowPassword(false)}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19.084"
                                  height="14"
                                  viewBox="0 0 19.084 14"
                                >
                                  <g id="eye" transform="translate(-0.458 -3)">
                                    <path
                                      id="Path_3"
                                      data-name="Path 3"
                                      d="M10,12a2,2,0,1,0-1.414-.586A2,2,0,0,0,10,12Z"
                                      fill="#707070"
                                    />
                                    <path
                                      id="Path_4"
                                      data-name="Path 4"
                                      d="M.458,10a10,10,0,0,1,19.084,0A10,10,0,0,1,.458,10ZM14,10a4,4,0,1,1-1.172-2.828A4,4,0,0,1,14,10Z"
                                      fill="#707070"
                                      fill-rule="evenodd"
                                    />
                                  </g>
                                </svg>
                              </div>
                            ) : (
                              <div onClick={(e) => setShowPassword(true)}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19.084"
                                  height="15.975"
                                  viewBox="0 0 19.084 15.975"
                                >
                                  <g
                                    id="eye-off"
                                    transform="translate(-0.458 -2.012)"
                                  >
                                    <path
                                      id="Path_5"
                                      data-name="Path 5"
                                      d="M3.707,2.293A1,1,0,0,0,2.293,3.707l14,14a1,1,0,0,0,1.414-1.414L16.234,14.82A10.014,10.014,0,0,0,19.542,10,10.006,10.006,0,0,0,5.488,4.074L3.708,2.293Zm4.261,4.26L9.482,8.068a2,2,0,0,1,2.45,2.45l1.514,1.514A4,4,0,0,0,7.968,6.554Z"
                                      fill="#707070"
                                      fill-rule="evenodd"
                                    />
                                    <path
                                      id="Path_6"
                                      data-name="Path 6"
                                      d="M12.454,16.7l-2.7-2.705a4,4,0,0,1-3.742-3.741L2.335,6.578A9.98,9.98,0,0,0,.458,10a10.016,10.016,0,0,0,12,6.7Z"
                                      fill="#707070"
                                    />
                                  </g>
                                </svg>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <p>
                        حداقل 8 کارکتر، با حرف بزرگ و لاتین شروع شود، ترکیبی از
                        حروف و اعداد باشد{" "}
                      </p>
                    </div>
                    <div className="text-center w-100">
                      <button
                        disabled={flag}
                        type="button"
                        className="btn w-100 btn-submit btn-block spinner-button py-2"
                        id="submit"
                        data-loading-text="<i className='fas fa-spinner fa-pulse'></i>"
                        onClick={handelSubmit}
                      >
                        {isLoading ? (
                          <img
                            src={"./loading.svg"}
                            alt={""}
                            className={"w-loading"}
                          />
                        ) : (
                          <span>ورود</span>
                        )}
                      </button>

                      <p className="pt-3 mymedium text-medium text-end css-pt343">
                        رمز عبور رو فراموش کردید؟
                        <Link
                          to={"/forgetpassword"}
                          className="text-custom mymedium pe-2 text-medium"
                        >
                          بازیابی رمز عبور
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
